@if (largeView || !selectedEvent) {
  <div class="d-flex flex-column flex-md-row input-btn-group mb-lg-3">
    <div class="mb-2 mb-lg-0 col-lg-2">
      <button
        class="btn btn-primary btn-lg w-100"
        (click)="openAddFeedbackForm(feedbackRef)"
      >
        + New
      </button>
    </div>
    @if (initialCount !== fullCount && fullCount > 0) {
      <div class="ms-md-2 mb-2 mb-lg-0 col-lg-2">
        <button
          class="btn btn-secondary btn-lg w-100"
          (click)="showAllFeedbacks()"
        >
          {{ showDefaultFeedbacks ? "Show All" : "Reset" }}
        </button>
      </div>
    }
    @if (!showDefaultFeedbacks && fullCount > 5) {
      <div class="ms-md-2 flex-md-grow-1 mb-2 mb-md-0">
        <gtapp-auto-complete
          [data]="feedbackDropDownList"
          placeHolder="Search"
          searchKeyword="company_name"
          [itemTemplate]="feedbcakTemplate"
          (inputChanged)="onFeedBackLookup($event)"
          (selected)="onRowClick($event)"
          (submitted)="globalFilter = $event; getFeedbacks()"
        >
        </gtapp-auto-complete>
        <ng-template #feedbcakTemplate let-item>
          <div class="small">{{ item?.feedback }}</div>
        </ng-template>
      </div>
    }
  </div>
}

<div
  class="row row-cols-1"
  [ngClass]="selectedEvent ? 'row-cols-lg-2' : 'row-cols-lg-1'"
>
  <div class="col">
    <gtapp-gt-table
      [desktopTableBackendData]="
        selectedEvent && !largeView ? [selectedEvent] : feedbacks
      "
      [desktopTableDetails]="deskTopTableDetail"
      [otherParams]="selectedEvent && !largeView ? {} : otherParams"
      (sortColumn)="sortColumn($event)"
      (paginationChange)="onChangePagination($event)"
      (rowClick)="onRowClick($event)"
    ></gtapp-gt-table>
  </div>

  @if (selectedEvent) {
    <div class="col mt-lg-4 p-3">
      <div class="text-end mb-2">
        <button (click)="openTemplate(deleteRef)" class="btn btn-sm btn-danger">
          Delete Inquiry
        </button>
      </div>
      <dl>
        <dt class="small-font">Inquiry</dt>
        <dd class="gt-multi-line">
          {{
            selectedEvent?.feedback === "null" ||
            selectedEvent?.feedback === "undefined"
              ? ""
              : selectedEvent?.feedback
          }}
        </dd>
      </dl>
      <!-- Comment section -->
      @if (selectedEvent?.updates?.length > 0) {
        <div class="overflow-45vh mb-4">
          @for (update of selectedEvent?.updates; track update) {
            <div>
              <dl
                class="d-flex flex-column flex-wrap border rounded p-2 mb-2 shadow"
              >
                <dt>
                  <div class="d-flex">
                    <div class="flex-grow-1 small-font">
                      {{ update?.updated_at | customDate: "d MMM y HH:mm" }} |
                      {{
                        update?.updated_by?.is_superuser
                          ? "Support Team"
                          : update?.updated_by?.full_name
                      }}
                    </div>
                    @if (
                      update?.event_action?.key === 1 &&
                      !update?.updated_by?.is_superuser
                    ) {
                      <div (click)="deleteComment(update)">
                        <i
                          class="fs-5 fa-solid fa-circle-minus text-danger"
                        ></i>
                      </div>
                    }
                  </div>
                </dt>
                @if (update?.event_action?.key === 1) {
                  <dd class="gt-multi-line">
                    @if (
                      update?.description !== "null" &&
                      update?.description !== "undefined"
                    ) {
                      @for (
                        part of update?.description | misc: "generateLinks";
                        track part
                      ) {
                        @if (part?.url) {
                          <a
                            [href]="part?.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ part?.url }}</a
                          >
                        } @else {
                          {{ part }}
                        }
                      }
                    }
                    @if (update?.file_url) {
                      <div class="text-end">
                        <button
                          class="btn btn-sm btn-outline-primary"
                          (click)="onOpenFile(update)"
                        >
                          Image Preview
                        </button>
                      </div>
                    }
                  </dd>
                }
                @if (update?.event_action?.key === 0) {
                  <dd>
                    STATUS:
                    {{ update?.status?.value }}
                  </dd>
                }
              </dl>
            </div>
          }
        </div>
      }
      @if (selectedEvent?.status != "COMPLETED") {
        <dl>
          <div class="row-cols-1">
            <div class="col form-group input-group">
              <textarea
                rows="3"
                class="form-control"
                type="text"
                placeholder="Add Update"
                [(ngModel)]="newComment"
                id="updateCommentBox1"
              ></textarea>
              @if (newComment) {
                <span
                  class="input-group-text"
                  (click)="clearAndFocusTextBox('updateCommentBox1')"
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
            <!-- <div class="my-2 small">
              @if(feedbackAttachment?.fileUrl){
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <img src="{{ feedbackAttachment?.fileUrl }}" width="200" />
                  </div>
                  <div>
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      (click)="feedbackAttachment = {}"
                      >
                      Delete Photo
                    </button>
                  </div>
                </div>
                }@else {
                <div>
                  <button
                    class="btn btn-outline-primary btn-sm"
                    (click)="attachImageToQuery()"
                    >
                    Add Photo (Optional)
                  </button>
                  <span class="small text-secondary">
                    Add an image so that we can understand you better</span
                    >
                  </div>
                }
              </div> -->
          </div>
        </dl>
      }
      <div class="row row-cols-2">
        <div class="col">
          <button
            (click)="hideDetails()"
            class="btn btn-lg btn-dark btn-lg w-100"
          >
            Cancel
          </button>
        </div>
        @if (newComment) {
          <div class="col">
            <button
              (click)="addComment()"
              class="btn btn-lg btn-primary btn-lg w-100"
              [disabled]="!newComment"
            >
              Update
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>

<!-- Delete feedback dialog -->
<ng-template #deleteRef let-deleteRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Delete Inquiry
      <span class="float-end" (click)="deleteRef.close()"
        ><i class="fa-solid fa-xmark"></i
      ></span>
    </div>
    <div class="form-floating">
      <input
        class="form-control"
        type="text"
        [(ngModel)]="deleteReason"
        placeholder="Reason (Optional)"
      />
      <label>Reason (Optional)</label>
    </div>
    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button class="btn btn-dark btn-lg w-100" (click)="deleteRef.close()">
          Cancel
        </button>
      </div>
      <div class="col">
        <button class="btn btn-primary btn-lg w-100" (click)="deleteFeedBack()">
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!-- ADD FEEDBACK POPOVER / DIALOG -->
<ng-template #feedbackRef let-feedbackRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Contact Form

      <span
        class="float-end"
        (click)="
          feedbackRef.close('close'); showHideDraggableFeedbackBtn(false)
        "
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="p-1 mb-2">
      <form [formGroup]="feedbackForm" class="row-cols-1 gy-2">
        <div class="col form-group input-group">
          <textarea
            class="form-control"
            cols="32"
            rows="5"
            wrap="hard"
            maxlength="340"
            placeholder="Need help or have feedback? Please tell us how we can help."
            formControlName="feedback"
            id="updateCommentBox"
          ></textarea>
          @if (feedbackForm.value.feedback) {
            <span
              class="input-group-text"
              (click)="clearAndFocusTextBox('updateCommentBox')"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      </form>
    </div>
    <!-- <div class="p-1 small">
        @if(feedbackAttachment?.fileUrl){
          <div class="d-flex">
            <div class="flex-grow-1">
              <img src="{{ feedbackAttachment?.fileUrl }}" width="200" />
            </div>
            <div>
              <button
                type="button"
                class="btn btn-outline-danger"
                (click)="feedbackAttachment = {}"
                >
                Delete Photo
              </button>
            </div>
          </div>

          }@else {
          <div>
            <button
              class="btn btn-outline-primary btn-sm"
              (click)="attachImageToQuery()"
              >
              Add Photo (Optional)
            </button>
            Add an image so that we can understand you better
          </div>
        }
      </div> -->
    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-dark btn-lg w-100"
          (click)="
            feedbackRef.close('close'); showHideDraggableFeedbackBtn(false)
          "
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          (click)="
            addFeedback();
            feedbackRef.close();
            showHideDraggableFeedbackBtn(false)
          "
          class="btn btn-primary btn-lg w-100"
          [disabled]="!feedbackForm.valid"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>
